import DTO from './DTO';
import {
  email,
  maxLength50,
  minLength3,
  trimError, onlyLettersAndHyphen,
} from '../utils/validation';
import DtoType from './converters/DtoType';
import RoleDTO from './RoleDTO';

class AuthorizedUserDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'user.id',
      },
      {
        name: 'login',
        type: String,
        validators: { maxLength50 },
        labelKey: 'login',
      },
      {
        name: 'email',
        type: String,
        validators: { maxLength50, email },
        labelKey: 'email',
      },
      {
        name: 'password',
        type: String,
        // validators: {required, maxLength255, minLength5},
        validators: { maxLength50 },
        labelKey: 'password',
      },
      {
        name: 'password_confirmation',
        type: String,
        // validators: {required, maxLength255, minLength5},
        validators: { maxLength50 },
        labelKey: 'password_confirmation',
      },
      {
        name: 'username',
        type: String,
        validators: {
          maxLength50, minLength3, onlyLettersAndHyphen, trimError,
        },
        labelKey: 'username',
      },
      {
        name: 'role',
        type: DtoType(RoleDTO),
        validators: {},
        labelKey: 'role',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getRegistrationData() {
    return {
      username: this.login,
      password: this.password,
    };
  }

  getData() {
    const data = {
      email: this.email,
      name: this.name,
    };
    if (this.password) {
      data.password = this.password;
      data.password_confirmation = this.password;
    }
    return data;
  }

  getLoginData() {
    return {
      username: this.login,
      password: this.password,
    };
  }

  getForgotData() {
    return {
      email: this.email,
    };
  }
}

export default AuthorizedUserDTO;
